
export type ConfirmDeleteModalType = 'portfolio' | 'portfolioPage' | 'folder' | 'lesson';

class ConfirmDeleteModalController {
    
    private close:Function; //injected from modal-service
    private closeCallback:Function;
    
    public deleteAction: string = 'delete';
    public title: string;
    public baseObjectId: string;
    public type: ConfirmDeleteModalType;
    public folderType: 'portfolio' | 'lesson';
    public unfollowShare: boolean = false;
	private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	// @ngInject
	constructor(
		public $timeout : ng.ITimeoutService,
		public ModalService	,
		public $element
	){}
	
	public onConfirmDelete = () => {
	    this.closeModal(true);
	}

	public $onInit(){
		// Set initial focus to the close button after render
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}

	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			this.close();
		}

		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		const focusableElements = modalEl.querySelectorAll(this.focusableSelector);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0] as HTMLElement;
		const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

		if (event.shiftKey) {
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	}
	
    private closeModal = (confirmDelete = false) =>{
		if(this.closeCallback != null){
			this.closeCallback()(confirmDelete);
		}
		
		if(this.close != null){
			this.close();
		}
		
		this.ModalService.closeModals();
		// Restore focus to the previously focused element
		if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
			this.previouslyFocusedElement.focus();
		}
    }
    
}

class ConfirmDeleteModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    title: "<",
	    baseObjectId: "<",
	    deleteAction: "<?",
	    type: "<",
	    folderType: "<?",
	    close:'&?',
		closeCallback:'&',
		unfollowShare: "<",
	};

	public controller = ConfirmDeleteModalController;
	public controllerAs = 'confirmDeleteModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/confirm-delete-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ConfirmDeleteModal };
